<template>
    <div class="container">
        <div class="bar">
            <table>
                <tr>
                    <template v-for="(percent, index) in percents.concat(remainingPercent)">
                        <td v-if="percent > 0" :key="index"
                            :style="{ width: percent + '%', backgroundColor: finalColors[index] }">
                        </td>
                    </template>
                </tr>
            </table>
        </div>
        <table class="description">
            <tr>
                <template v-for="(percent, index) in percents.concat(remainingPercent)">
                    <td v-if="percent > 0" :key="index" :style="{ width: percent + '%', color: finalColors[index]}">
                        <span class="text">{{percent + '%'}}</span>
                    </td>
                </template>
            </tr>
        </table>
    </div>
</template>
<script>
    import _ from "lodash";


    export default {
        computed: {
            percents: function() {
                return this.options.value.map(val => {
                    return _.round(val * 100 / this.options.total, 2);
                });
            },
            remainingPercent() {
                return _.round(100 - this.percents.reduce((sum, curr) => sum + curr), 2);
            },
            finalColors() {
                return ['#00C1C8', '#FF9966'];
            }
        },
        props: {
            options: null
        }
    }
</script>
<style scoped>
    .bar {
        border: 1px solid #bcbcbc;
        overflow: hidden;
        border-radius: 12px;
    }

    .bar table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 12px;
        height: 18px;
    }

    .container {
        position: relative;
    }

    .description {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 28px;
    }
</style>